import React, { useState } from 'react';
import { Mail, X, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';

const EmailVerificationBanner = ({ userEmail, onResend, onDismiss }) => {
  const [isResending, setIsResending] = useState(false);
  const [message, setMessage] = useState('');
  const [isDismissed, setIsDismissed] = useState(false);

  const handleResend = async () => {
    setIsResending(true);
    setMessage('');
    
    try {
      await onResend();
      setMessage('Verification email sent! Check your inbox.');
    } catch (error) {
      if (error.message.includes('wait')) {
        setMessage(error.message);
      } else {
        setMessage('Failed to send email. Please try again.');
      }
    } finally {
      setIsResending(false);
    }
  };

  const handleDismiss = () => {
    setIsDismissed(true);
    if (onDismiss) {
      onDismiss();
    }
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 text-white shadow-lg relative">
      <div className="max-w-7xl mx-auto px-3 py-2 sm:px-6 sm:py-3 lg:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-3">
          <div className="flex items-start gap-2 sm:gap-3 flex-1 w-full">
            <div className="flex-shrink-0 flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white/20">
              <AlertCircle className="w-4 h-4 sm:w-5 sm:h-5" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-xs sm:text-sm md:text-base">
                📧 Verify your email
              </p>
              <p className="text-[10px] sm:text-xs md:text-sm opacity-90 break-words">
                Sent to <strong className="break-all">{userEmail}</strong>
              </p>
              <p className="text-[10px] sm:text-xs opacity-95 mt-0.5">
                💡 Check spam/junk folder
              </p>
              {message && (
                <p className="text-[10px] sm:text-xs mt-1 font-medium bg-white/20 px-2 py-0.5 sm:py-1 rounded inline-block">
                  {message}
                </p>
              )}
            </div>
          </div>

          <div className="flex items-center gap-2 w-full sm:w-auto">
            <Button
              onClick={handleResend}
              disabled={isResending}
              className="flex-1 sm:flex-initial px-3 sm:px-4 py-1.5 sm:py-2 rounded-full font-semibold text-xs sm:text-sm bg-white/20 hover:bg-white/30 backdrop-blur-sm transition-all"
            >
              <Mail className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 inline" />
              {isResending ? 'Sending...' : 'Resend'}
            </Button>
            
            <button
              onClick={handleDismiss}
              className="flex-shrink-0 p-1.5 sm:p-2 rounded-full hover:bg-white/20 transition-all"
              aria-label="Dismiss"
            >
              <X className="w-3 h-3 sm:w-4 sm:h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
